/** 認証不要のパス */
export const PUBLIC_PATHS = [
  '/login',
  '/account/application/new/truck-driver',
  '/account/application/new/office',
  '/account/application/new/guest-truck-driver',
  '/account/application/new/jrf',
  '/account/application/new/partner',
  '/account/application/new/corporation',
] as const as string[];

/**
 * 指定のパスが認証不要のパスかどうかを判定する関数
 *
 * ※末尾のスラッシュは考慮しないため、例えば`/login`と`/login/`は同じパスとみなされる。
 *
 * @param path 判定するパス
 * @returns 認証不要のパスであればtrue、そうでなければfalse
 */
export const isPublicPath = (path: string): boolean => {
  const normalizedPath = path.endsWith('/') ? path.slice(0, -1) : path;
  return PUBLIC_PATHS.includes(normalizedPath);
};
